var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWistorMarkColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1359;}.cls-2{fill:url(#Naamloos_verloop_419-2);}.cls-3{fill:#6950ff;}.cls-4{fill:url(#Naamloos_verloop_419);}.cls-5{fill:url(#Naamloos_verloop_728-2);}.cls-6{fill:url(#Naamloos_verloop_728);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_728",
    x1: -2875.77,
    y1: 3792.53,
    x2: -2959.51,
    y2: 3881.36,
    gradientTransform: "translate(-2108.71 4240.67) rotate(179.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#1d1343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#1d133b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_728-2",
    x1: 637.41,
    y1: 958.7,
    x2: 550.44,
    y2: 1050.96,
    gradientTransform: "translate(216.17 105.92) rotate(-.19)",
    xlinkHref: "#Naamloos_verloop_728"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_419",
    x1: 336.97,
    y1: 1134.22,
    x2: 227.87,
    y2: 548.26,
    gradientTransform: "translate(216.17 105.92) rotate(-.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29235c",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2e2669",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3a2f88",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#4537a5",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#4f3dbd",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#5743d2",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5d48e2",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#624bef",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#664ef8",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#684ffd",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6950ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_419-2",
    x1: 820.59,
    y1: 164,
    x2: 823.59,
    y2: 788.97,
    xlinkHref: "#Naamloos_verloop_419"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M843.55,371.17c-1.19-1.66-2.42-3.28-3.69-4.88-21.97-27.59-57.71-43.72-95.53-45.41-64.97,1.51-138.49-4.95-172.56,37.42l-87.23,112.43,214.9,273.21,211.88-274.65-67.77-98.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M864.46,529.64s-249.18-186.97-201.29-199.69c109.89-29.19,157.53,25.83,157.53,25.83l90.61,113.47-46.86,60.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M771.46,1126.44c1.19,1.66,2.42,3.28,3.69,4.88,21.97,27.59,54.32,46.2,92.15,47.89,64.97-1.51,146.24,7.07,178.67-43.46l81.46-104.99-215.03-272.77-212.21,273.5,71.27,94.95Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M747.04,971.1s249.5,188.26,201.29,199.69c-93.3,22.12-146.3-8.87-146.3-8.87l-101.84-130.43,46.86-60.39Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M780.53,1134.07c-1.28-1.59-2.5-3.22-3.69-4.88L373.78,609.54l-211.88,274.65,170.52,216.68c33.47,51.4,100.1,79.78,166.68,79.55l369.78-1.23c1.39,0,2.64-.08,4.16-.14-37.83-1.69-70.55-17.4-92.52-45Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M780.53,1134.07c-1.28-1.59-2.5-3.22-3.69-4.88L373.78,609.54l-211.63,274.88,170.27,216.46c33.47,51.4,100.1,79.78,166.68,79.55l369.78-1.23c1.39,0,2.64-.08,4.16-.14-37.83-1.69-70.55-17.4-92.52-45Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1273.23,373.08c-1.19-1.66-2.42-3.28-3.69-4.88-21.97-27.59-55.31-46.94-93.13-48.63-16.17,.38-32.87,.26-49.36,.53-4.75-.28-9.56-.45-14.52-.44l-369.78,1.23c-1.39,0-2.77,.11-4.17,.14,37.83,1.69,71.22,19.23,93.19,46.82,1.28,1.59,2.5,3.22,3.69,4.88l290.77,369.8,211.88-274.65-64.87-94.78Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1273.23,373.08c-1.19-1.66-2.42-3.28-3.69-4.88-21.97-27.59-55.31-46.94-93.13-48.63-16.17,.38-32.87,.26-49.36,.53-4.75-.28-9.56-.45-14.52-.44l-369.78,1.23c-1.39,0-2.77,.11-4.17,.14,37.83,1.69,71.22,19.23,93.19,46.82,1.28,1.59,2.5,3.22,3.69,4.88l290.77,369.8,211.88-274.65-64.87-94.78Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWistorMarkColor);
export default __webpack_public_path__ + "static/media/wistor-mark-color.27e292d1.svg";
export { ForwardRef as ReactComponent };